// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"search_searchForm__22IEw","searchFormLabel":"search_searchFormLabel__bV1PC","searchFormBtnSearch":"search_searchFormBtnSearch__1zA3p"};